module.exports = __webpack_public_path__ + "static/img/cash.2a965234.png";